import { AxiosError } from 'axios';
import useSWRImmutable from 'swr/immutable';

import { apiEndpoints } from '../lib';
import { CurrentLoanInfoT } from '../types';

type ActiveLoanSummaryResponseT = {
  data: CurrentLoanInfoT;
};

export const useActiveLoanInfo = (accountId: string) => {
  const {
    data,
    error,
    isLoading,
  } = useSWRImmutable<ActiveLoanSummaryResponseT, AxiosError>(
    apiEndpoints.activeLoanSummary(accountId),
  );

  return {
    activeLoanInfo: data?.data,
    error,
    isLoading,
  };
};
